export default "__VITE_ASSET__CvxXjDpy__"